export default __webpack_public_path__ + "static/media/step-1.29e71ec3.jpeg";